import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: "What is BigE Sales Coach?",
    answer: "BigE Sales Coach is an AI-powered sales training platform built for Sales Programs and Enterprise sales teams. It provides realistic role-play practice with AI buyers, instant feedback based on proven judging rubrics, and progress tracking to help reps and students sharpen their sales skills at scale.",
  },
  {
    question: "How does the AI buyer work?",
    answer: "Our AI buyers are trained on real sales competition scripts and respond dynamically to your questions and pitches. They simulate realistic buyer behavior including objections, information revelation based on your discovery questions, and natural conversation flow.",
  },
  {
    question: "What scoring criteria do you use?",
    answer: "We use proven sales judging rubrics tailored to your context — collegiate competition rubrics for Sales Programs, and customizable enterprise rubrics (discovery, qualification, objection handling, close, communication, and overall performance) for Enterprise teams. Each category is scored with specific feedback on how to improve.",
  },
  {
    question: "Can I practice with voice?",
    answer: "Yes! bigE supports full voice conversation mode using advanced speech-to-text technology. You can conduct entire role-plays by speaking naturally, just like you would in an actual competition. The AI buyer also responds with synthesized voice for a realistic experience.",
  },
  {
    question: "What is 'Stay in the Ring' mode?",
    answer: "Stay in the Ring is our challenge mode for objection handling practice. In this mode, if you give a weak response to an objection (not following the Clarify-Address-Confirm framework), the session ends immediately. It's designed to build mental toughness and ensure you're ready for pressure situations.",
  },
  {
    question: "How is this different from practicing with friends?",
    answer: "bigE provides several advantages: 24/7 availability, consistent buyer behavior based on competition scripts, instant structured feedback using official rubrics, detailed analytics to track improvement over time, and the ability to practice specific scenarios repeatedly without social awkwardness.",
  },
  {
    question: "Do I need any special equipment?",
    answer: "Just a computer with a microphone. All practice is done in voice mode for the most realistic experience.",
  },
  {
    question: "Can professors, coaches, or sales leaders use this with their teams?",
    answer: "Yes. We offer Sales Programs plans for universities and Enterprise plans for sales organizations — including team dashboards, custom scenarios, role-based analytics, and volume licensing tailored to your curriculum or playbook.",
  },
  {
    question: "What use cases does bigE support?",
    answer: "BigE supports Sales Programs preparing students for major collegiate competitions (NCSC, ICSC, regionals) and Enterprise sales teams onboarding, certifying, and continuously coaching reps on real-world deals. The underlying sales skills — discovery, objection handling, and closing — apply universally.",
  },
];

const FAQ = () => {
  return (
    <section id="faq" className="py-20 sm:py-32 relative">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16 sm:mb-20">
          <span className="inline-block px-4 py-1.5 rounded-full glass text-sm font-medium text-emerald-400 mb-4">
            FAQ
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight mb-4">
            Frequently Asked <span className="text-gradient">Questions</span>
          </h2>
          <p className="text-muted-foreground text-lg">
            Everything you need to know about bigE sales coach
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="glass rounded-xl px-6 border-none"
              >
                <AccordionTrigger className="text-left font-display font-semibold text-base sm:text-lg hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm sm:text-base leading-relaxed pb-5">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
